import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationWeightPluginService } from './weight.service';
import { UntypedFormControl, UntypedFormGroup, UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { ModalComponent } from '../../../modal/modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { ConfirmComponent } from '../../../modal/confirm.component';

@Component({
    selector: 'installation-weight-edit',
    templateUrl: './weight-edit.component.html',
    standalone: false
})
export class InstallationWeightEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;

  public units: any[];
  public currentItem: any;
  private weightToRemove: number;

  private sub = new Subscription();

  @ViewChild('unitsModal', { static: true }) unitsModal: ModalComponent;
  @ViewChild('weightDeleteConfirm', { static: true }) weightDeleteConfirm: ConfirmComponent;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationWeightPluginService,
    private fb: UntypedFormBuilder
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['weights'];
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateWeight(this.inspectionId, this.pointId, this.pluginId, model.weights).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public add() {
    const control = <UntypedFormArray>this.editForm.controls['weights'];

    control.push(this.initWeight());
  }

  public remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['weights'];
    control.removeAt(this.weightToRemove);
  }

  public onClose(e: any) {
    this.editForm.controls['Units'].markAsTouched();
  }

  public selectUnitsMenu(item: any) {
    const selectedIndex = this.currentItem.controls['Units'].value === item.selectedIndex ? '' : item.selectedIndex;
    this.currentItem.controls['Units'].setValue(selectedIndex);
  }

  public openUnitsSelector(selectedIndex: number, i: number): void {
    this.openSelector(this.unitsModal, this.units, selectedIndex || selectedIndex === 0 ? selectedIndex : -1);
    const control = <UntypedFormArray>this.editForm.controls['weights'];
    this.currentItem = control.controls[i];
  }

  public openQuestionDeleteConfirm(i: number) {
    this.weightDeleteConfirm.open();
    this.weightToRemove = i;
  }

  public checkIfPositive(event) {
    if (event.target.value < 0) event.target.value = 0;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.units = this.pluginService.getWeightUnits();
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      if (!this.plugin.config.Weights?.length) {
        this.plugin.config.Weights = this.plugin.config.Weight ? [this.plugin.config.Weight] : [];
        this.plugin.config.Weight = null;
      }
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = this.fb.group({
      weights: this.fb.array([])
    });
    const control = <UntypedFormArray>this.editForm.controls['weights'];
    _.forEach(this.plugin.config.Weights, (el) => {
      control.push(this.initWeight(el));
    });
  }

  private initWeight(el?: any) {
    return this.fb.group({
      Label: new UntypedFormControl(el?.Label ?? ''),
      WeightValue: new UntypedFormControl(el?.WeightValue ?? ''),
      Units: new UntypedFormControl(el?.Units ?? -1)
    });
  }
}
